import { PropsWithChildren } from 'react';

export const Empty = (props: PropsWithChildren<any>) => <>{props.children}</>;
